import styled, { css } from 'styled-components';

export const Topic = styled.span`
	font-size: 0.9rem;
	font-weight: 600;
	margin-right: 0.5rem;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const RPNTopic = styled.span`
	font-size: 0.9rem;
	font-weight: 600;
	margin-right: 0.5rem;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const Value = styled.span`
	font-size: 0.9rem;
	font-weight: 400;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

interface ScoreProps {
	$danger: 'high' | 'medium' | 'low';
}

export const Score = styled.span<ScoreProps>`
	${({ theme, $danger }) => css`
		color: ${theme.palette.risk[$danger].default};
		font-weight: 600;
		font-size: 0.9rem;
		display: block;
		padding: 0.5rem 1rem;
		border-radius: 0.25rem;
		border: 1px solid ${theme.palette.risk[$danger].default};
		background-color: ${theme.palette.risk[$danger][100]};
		width: 100%;
		height: 38px;
		max-width: 94px;
		text-align: center;
		align-items: center;

		@media (min-width: 1600px) {
			font-size: 0.9rem;
		}
	`}
`;
